<div class="informations border-light border rounded-lg bg-white p-8 md:mt-10 mt-5">
  <div class="flex items-center justify-between mb-6">
    <h1 class="font-app-bold text-xl">
      {{ "userInfo.addressTitle" | translate }}
    </h1>
  </div>
  <hr class="text-lightest mb-4" />
  <div class="md:grid md:grid-cols-4 gap-4 flex flex-col mb-4">
    <div>
      <p class="text-dark">{{ "userInfo.address" | translate }}</p>
      <div class="text-darkest font-bold">
        <p>
          {{ isFirstContract && member?.address1 ? member?.address1 : "-" }}
        </p>
      </div>
    </div>
    <div>
      <p class="text-dark">{{ "userInfo.addressComplement" | translate }}</p>
      <div class="text-darkest font-bold">
        <p>
          {{ isFirstContract && member?.address2 ? member?.address2 : "-" }}
        </p>
      </div>
    </div>
    <div>
      <p class="text-dark">{{ "userInfo.zipCode" | translate }}</p>
      <div class="text-darkest font-bold">
        <p>{{ isFirstContract && member?.zipCode ? member?.zipCode : "-" }}</p>
      </div>
    </div>
    <div>
      <p class="text-dark">{{ "userInfo.city" | translate }}</p>
      <div class="text-darkest font-bold">
        <p>
          {{ isFirstContract && member?.addressCity ? member?.addressCity : "-" }}
        </p>
      </div>
    </div>
  </div>
</div>

